import React from 'react';

import classNames from 'classnames';
import { createStyles, DialogTitle, Icon, Theme, Typography, withStyles } from '@material-ui/core';
import MuiDialog, { DialogProps } from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import { Close } from '@material-ui/icons';

const styles = (theme: Theme) =>
  createStyles({
    header: {
      alignItems: 'center',
      background: theme.palette.text.primary,
      display: 'flex',
      padding: theme.spacing.unit * 2,
      '& *': {
        color: theme.palette.common.white,
      },
    },
    headerBlue: {
      background: theme.palette.primary.dark,
    },
    headerIcon: {
      display: 'flex',
      marginLeft: theme.spacing.unit,
    },
    headerText: {
      display: 'flex',
      flex: 1,
      marginLeft: theme.spacing.unit,
      whiteSpace: 'nowrap',
    },
  });

interface Props extends DialogProps {
  classes: any;
  headerIcon?: string;
  headerText?: string;
  variant?: 'primary';
}

const Dialog: React.FC<Props> = ({ classes, headerIcon, headerText, children, onClose, variant, ...other }) => (
  <MuiDialog onClose={onClose} {...other}>
    <DialogTitle className={classNames(classes.header, { [classes.headerBlue]: !!variant })} disableTypography>
      {headerIcon && <Icon className={classes.headerIcon}>{headerIcon}</Icon>}
      {headerText && (
        <Typography className={classes.headerText} variant="h6">
          {headerText}
        </Typography>
      )}
      {onClose && (
        <IconButton onClick={onClose} aria-label="close">
          <Close />
        </IconButton>
      )}
    </DialogTitle>
    {children}
  </MuiDialog>
);

export default withStyles(styles)(Dialog);
